import React, { useEffect } from "react";
import { FaEnvelope } from "react-icons/fa";
import { Button, Container, Form, FormGroup, Input, Label } from "reactstrap";
import AnimationCommon from "../common/AnimationCommon";

const ForgetPassword = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
  }, []);

  return (
    <section className='auth-page'>
      <AnimationCommon />
      <Container className='auth-card'>
        <div className='text-center'>
          <h2>Forgot Password</h2>
          <img src='assets/images/title-line.png' alt='title-line' className='img-fluid line' />
        </div>
        <div className='main'>
          <Form className='auth-form'>
            <FormGroup className='form-group'>
              <Label>Email</Label>
              <FaEnvelope className='icon-setting' />
              <Input required name='login[username]' type='email' placeholder='Email' />
            </FormGroup>
            <FormGroup className='form-group'>
              <Button className='submit' color='primary'>Send Code</Button>
            </FormGroup>
            <div className='or-saparator'>
              <span>or</span>
            </div>
            <h6 className='text-center mt-0 mb-3'>Sign in with:</h6>
            <div className='form-button d-sm-flex justify-content-center align-items-center text-center social-btns'>
              <Button className='submit fb' color='primary'>Sign in</Button>
              <Button className='submit ggl' color='danger'>Signup</Button>
            </div>
          </Form>
        </div>
      </Container>
    </section>
  );
};

export default ForgetPassword;
